export function isPro(s: "normal" | "pro-only" | "pro-removed"): boolean {
  return s !== "normal";
}
